import React, { useState } from 'react';

const DropdownMenu = ({ items, label }) => {
     const [isOpen, setIsOpen] = useState(false);

     const toggleDropdown = () => {
          setIsOpen(!isOpen);
     };

     const handleMouseLeave = () => {
          setIsOpen(false);
     }

     return (
          <div className="relative inline-block text-left" onMouseLeave={handleMouseLeave}>
               <div>
                    <button
                         type="button"
                         onClick={toggleDropdown}
                         id="menu-button"
                         aria-expanded="true"
                         aria-haspopup="true"
                         aria-controls="menu-items"
                         className={`inline-flex justify-center w-full p-2 text-xs md:text-sm font-semibold text-gray-100 rounded hover:bg-emerald-800 ${isOpen ? 'bg-emerald-800' : ''} focus:outline-none`}
                    >
                         {label}
                         <svg
                              className="w-5 h-5 ml-2 -mr-1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                         >
                              <path
                                   fillRule="evenodd"
                                   d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                   clipRule="evenodd"
                              />
                         </svg>
                    </button>
               </div>

               {isOpen && (
                    <div
                         className="absolute left-0 max-w-screen-lg origin-top-right rounded-md shadow-lg min-w-max bg-emerald-600 focus:outline-none"
                         role="menu"
                         aria-orientation="vertical"
                         aria-labelledby="menu-button"
                    >
                         <div className="flex justify-between px-2 py-4 text-gray-200 divide-x divide-emerald-700">
                              {items.map((item, index) => (
                                   <div className='flex-1 px-2' key={index}>
                                        <ul className="list-inside">
                                             <li className="font-medium">
                                                  {item.subcategories.length == 0 ? (
                                                       <a href={item.url} className="p-1 text-sm text-gray-200 rounded hover:text-white hover:bg-emerald-700">
                                                            {item.name}
                                                       </a>
                                                  ) : (
                                                       <span className="p-1 text-sm text-gray-200 rounded">
                                                            {item.name}
                                                       </span>
                                                  )}
                                                  <ul className="ml-2 list-none list-inside">
                                                       {item.subcategories.map((subItem, subIndex) => (
                                                            <li key={subIndex} className="py-1">
                                                                 <a href={subItem.url} className="p-1 text-sm text-gray-200 rounded hover:text-white hover:bg-emerald-700">
                                                                      {subItem.name}
                                                                 </a>
                                                                 <ul className="ml-2 list-none list-inside">
                                                                      {subItem.tags.map((tag, tagIndex) => (
                                                                           <li key={tagIndex} className="p-1 rounded hover:bg-emerald-700">
                                                                                <a href={tag.url} className="text-sm text-gray-200 hover:text-white" onClick={toggleDropdown}>
                                                                                     {tag.name}
                                                                                </a>
                                                                           </li>
                                                                      ))}
                                                                 </ul>
                                                            </li>
                                                       ))}
                                                  </ul>
                                             </li>
                                        </ul>
                                   </div>
                              ))}
                         </div>
                    </div>
               )}
          </div>
     );
};

export default DropdownMenu;